import React from 'react';

interface AboutTabProps {}

export const AboutTab: React.FC<AboutTabProps> = () => {
  return (
    <div className="flex flex-col space-y-6 w-full min-w-0 border border-gray-200 dark:border-gray-700 rounded-lg p-6 shadow-sm">
      <div className="space-y-6 w-full max-w-3xl mx-auto divide-y divide-gray-200 dark:divide-gray-700">
        <section className="pb-6 space-y-4">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">About Policy Generator</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            Policy Generator is a React-based tool that enables you to visually create, configure, and preview Azure Policy definitions without writing JSON by hand. It offers an end-to-end interface for building policy rules, setting parameters, and exporting deployable policy artifacts.
          </p>
        </section>

        <section className="py-6 space-y-4">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Key Features</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li><strong>Policy Design Interface:</strong> Build and configure Azure policies through an intuitive UI.</li>
            <li><strong>Condition Builder:</strong> Visually define nested conditions and rule groups.</li>
            <li><strong>Parameter Configuration:</strong> Add, validate, and customize policy parameters with real-time feedback.</li>
            <li><strong>Live JSON Preview:</strong> Instantly view the generated Azure Policy JSON as you edit.</li>
            <li><strong>Import Existing Policies:</strong> Upload or paste policy JSON to load and modify existing definitions.</li>
            <li><strong>Exportable Definitions:</strong> Download or copy deploy-ready policy JSON for your Azure environment.</li>
          </ul>
        </section>

        <section className="py-6 space-y-4">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">How to Use</h2>
          <ol className="list-decimal list-inside space-y-1 text-gray-700 dark:text-gray-300">
            <li>Enter core policy metadata (name, description, category).</li>
            <li>Use the visual designer to build and nest conditions.</li>
            <li>Select policy effects (e.g., Audit, Deny).</li>
            <li>Define and validate parameters with live feedback.</li>
            <li>Preview the generated JSON in real time.</li>
            <li>Export or copy the policy JSON for deployment.</li>
          </ol>
        </section>

        <section className="py-6 space-y-4">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Disclaimer</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            This tool is an independent project and is not developed, endorsed, or supported by Microsoft. Azure Policy Editor is a third-party tool designed to assist with Azure Policy creation, but it is not an official Microsoft product. The tool is still in the development stage.
          </p>
        </section>
      </div>
    </div>
  );
}; 